import { render } from "./FormAddOnProducts.vue?vue&type=template&id=af969d76&scoped=true"
import script from "./FormAddOnProducts.vue?vue&type=script&lang=js"
export * from "./FormAddOnProducts.vue?vue&type=script&lang=js"

import "./FormAddOnProducts.vue?vue&type=style&index=0&id=af969d76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af969d76"]])

export default __exports__